import type { CSSProperties } from "react";
import {
  designTokens,
  interfaceFont,
  type InterfaceColorMode,
} from "./tokens.js";

export type DesignActionTone =
  | "accent"
  | "success"
  | "error"
  | "warning"
  | "neutral";

/** Shared presentation for operator commands and semantic navigation links. */
export function designActionStyle(
  colorMode: InterfaceColorMode,
  tone: DesignActionTone = "accent",
  hasLabel = true,
  disabled = false,
): CSSProperties {
  const p = designTokens[colorMode];
  const filled = tone !== "neutral";
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    minHeight: 29,
    padding: hasLabel ? "5px 9px" : "5px 7px",
    border: `1px solid ${filled ? "transparent" : p.border}`,
    borderRadius: 6,
    background: filled ? p[tone] : p.surface,
    color: filled ? p.onAccent : p.text,
    font: `500 11px ${interfaceFont}`,
    lineHeight: 1.35,
    whiteSpace: "nowrap",
    cursor: disabled ? "default" : "pointer",
    opacity: disabled ? 0.45 : 1,
    flexShrink: 0,
    outlineOffset: 2,
    outlineColor: p.accent,
  };
}
